import { render, staticRenderFns } from "./AppFooterVersion.vue?vue&type=template&id=2463dafd"
import script from "./AppFooterVersion.vue?vue&type=script&lang=js"
export * from "./AppFooterVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports